module.exports = __webpack_public_path__ + "img/6.66b3cb03.svg";